import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PermissionService, RoutesService } from '@abp/ng.core';

@Injectable({
  providedIn: 'root',
})
export class RequiredMultiplePoliciesGuard {
  constructor(private permissionService: PermissionService, private routesService: RoutesService) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const permissions = (route.data.requiredMultiplePolicies ??
      route.data.routes.requiredMultiplePolicies) as string[];

    let result = false;

    for (let j = 0; j < permissions.length; j++) {
      const isGranted = this.permissionService.getGrantedPolicy(permissions[j]);

      result ||= isGranted;
    }

    return result;
  }

  checkRoutesForMultiplePolicies(): void {
    const flatItems = this.routesService.flat;

    for (let i = 0; i < flatItems.length; i++) {
      const item = flatItems[i] as any;

      if (Array.isArray(item.requiredMultiplePolicies)) {
        let result = false;

        for (let j = 0; j < item.requiredMultiplePolicies.length; j++) {
          const isGranted = this.permissionService.getGrantedPolicy(
            item.requiredMultiplePolicies[j]
          );

          result ||= isGranted;
        }

        if (!result) {
          this.routesService.remove([item.name]);
        } else {
          item.name = item.getName(this.permissionService);

          this.routesService.patch(item.name, item);
        }
      }
    }
  }
}
